<div class="search-container">
  <input
    class="search-input"
    matInput
    [matAutocomplete]="auto"
    [formControl]="searchControl"
    [placeholder]="'Find teams, markets, events and more...' | translate"
    (keydown.enter)="onSearch()"
    type="search"
  />
  <button [disabled]="searchControl.value?.length === 0" (click)="onSearch()">
    @if (loader.state.value["search"]) {
      <mat-spinner
        style="margin-right: 1em"
        diameter="20"
        matSuffix
      ></mat-spinner>
    } @else {
      <mat-icon>search</mat-icon>
    }
  </button>
</div>

<mat-autocomplete #auto="matAutocomplete">
  @for (result of searchResults; track result; let i = $index) {
    <mat-option
      [routerLink]="searchService.getRouterLink(result)"
      [value]="result?.name"
    >
      <div class="result-item">
        <span class="name">
          {{ result?.name }}
        </span>
        <span class="date">
          {{ result?.startTime | date: "dd/MM" }}
        </span>
      </div>
      <span class="league"> ({{ result?.competitionName || "..." }}) </span>
    </mat-option>
    @if (i < searchResults.length - 1) {
      <mat-divider />
    }
  }
</mat-autocomplete>
